import moment from 'moment';
import _ from 'lodash';

export const required = (value) => {
  return (value ? undefined : 'Required');
}

export const minLength = (min) => (value) =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const maxLength = (max) => (value) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined;

export const phoneNumber = (value) =>
  value && !/^(0|[1-9][0-9])*$/i.test(value)
    ? 'Must be numeric'
    : undefined;

export const mobile = (value) =>
  // value && !/^(0|[1-9][0-9])*$/i.test(value)
  value && !/^(\+\d{1,3}[- ]?)?\d{10}$/i.test(value)
    ? 'Must be numeric'
    : undefined;

export const password = (value) =>
  value && value.length < 6
    ? 'Must be at least 6 characters'
    : undefined;

export const ip = (value) =>
  value && !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i.test(value)
    ? 'Invalid IP address'
    : undefined;

export const future = (inclusive) => (value) => {
  if (value &&
    ((inclusive && moment(value).isSameOrAfter(moment().startOf('d'))) || moment(value).isSameOrAfter(moment().startOf('d')))) {
    console.log('future:true');
    return undefined;
  }

  console.log('future:false');
  return 'Date must be in the future';
};

export const number = (value) => !_.isNumber(value) ? 'Invalid number' : null;
export const integer = (value) => !_.isInteger(value) ? 'Invalid number' : null;
export const positive = (value) => Number(value) >= 0 ? 'Number must be positive' : null;




// WEBPACK FOOTER //
// ./src/utils/formvalidation.js